export default "__VITE_ASSET__Dys8hnjr__"